import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useES(data = {}) {
  const { enabled = false, queryParams = '', configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getES() {
    return privateFetch.get(`/v1/admin/es${queryParams}`, configs).then((res) => res.data);
  }

  return useQuery(['ES', { data }], getES, { enabled, keepPreviousData: true });
}

export default useES;
